function Footer(){
    return(
        <footer>
            <p>Copyrigth © 2024 thomastamagni.co.uk All Right Reserved</p>
        </footer>
    )
}

export default Footer